import { createContext, useState } from "react";

export const EventFormContext = createContext();
export const EventFormProvider = ({ children }) => {
  console.log("in context file");
  const [formData, setFormData] = useState({
    eventTitle: "",
    eventType: "",
    eventDateStart: null,
    eventDateEnd: null,
    eventTimeStart: null,
    eventTimeEnd: null,
    timezone: "",
    eventUrl: "",
    numberOfParticipants: "",
    eventDescription: "",
    photo: null,
  });
  const [updatedFields, setUpdatedFields] = useState({});
  return (
    <EventFormContext.Provider
      value={{ formData, setFormData, updatedFields, setUpdatedFields }}
    >
      {children}
    </EventFormContext.Provider>
  );
};
